import React, { useEffect, useState } from "react";
import TrainingVideosService from "../../services/trainingVideos.service";
import { Timing } from "../GoogleAnalytics";

function TrainingInfoCard({ open, onClose }) {
    const [loading, setLoading] = useState(false);
    const [info, setInfo] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!open) return;

        const fetchData = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await TrainingVideosService.getAllLifewhereTerms();
                if (response !== undefined && response !== null) {
                    setInfo(response);
                }
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [open]);

    if (!open) return null;

    return (
        <div className="training-info-overlay">
            <div className="training-info-modal">
                <div className="training-info-header">
                    <h3 className="training-info-title">Training Info</h3>
                </div>
                <div className="training-info-table-container">
                    <table className="training-info-table">
                        <thead>
                        <tr>
                            <th className="training-info-turm">Term</th>
                            <th>Definition</th>
                        </tr>
                        </thead>
                        <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={2}>Loading...</td>
                            </tr>
                        ) : (
                            Array.isArray(info) && info.map((item, idx) => (
                                <tr key={idx}>
                                    <td className="training-info-turm">{item.term}</td>
                                    <td>{item.definition}</td>
                                </tr>
                            ))
                        )}
                        </tbody>
                    </table>
                </div>
                <button
                    className="alerts-tab-btn secondary-btn btn-small"
                    onClick={onClose}
                >
                    Close
                </button>
            </div>
        </div>
    );
}

export default TrainingInfoCard;